import React from 'react';

export function TableHeader({
    width,
    widthPercent,
    children,
    dense,
    fitted,
}: {
    width?: string;
    /** Share of the table's width, used with a fitted (fixed-layout) table. */
    widthPercent?: number;
    children?: React.ReactNode;
    dense?: boolean;
    fitted?: boolean;
}) {
    return (
        <th
            // A fitted table divides the available width between its columns,
            // so the heading has to be allowed to truncate. Left to
            // whitespace-nowrap it would set a floor under the column and push
            // the table wider than its container again.
            className={`${dense ? 'px-2 py-2' : 'px-4 py-3'} ${width || ''} ${
                fitted ? 'truncate' : 'whitespace-nowrap'
            } text-xs font-semibold text-foreground-secondary uppercase tracking-wide text-left bg-surface-muted border-b border-border`}
            style={widthPercent ? { width: `${widthPercent}%` } : undefined}
            title={fitted && typeof children === 'string' ? children : undefined}
        >
            {children}
        </th>
    );
}
